module.exports = __webpack_public_path__ + "files/e5b5846eef9c43e5de045da3fb05dfef.png";